import { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Row } from 'reactstrap';
import { usdFormat } from '../../../Utility/usdFormat';
import Loading from '../../../Components/Loading';
import { DashIcon } from '@primer/octicons-react';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import './Sales.css';

type QuarterData = {
    quarter: string;
    quarterQuotaCY: number;
    quarterSalesCY: number;
    quarterQuotaPercent: number;
}

type props = {
    data: QuarterData[];
}

const QuarterlySalesReportCard = ({ data }: props) => {
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4',]
    const [currentQuarter, setCurrentQuarter] = useState<string>('');
    const [loading, setLoading] = useState(false);
    
    const getQuarter = async () => {
        try {
            const today = new Date().getMonth();
            const quarterNum = Math.floor(today / 3) + 1;
            setCurrentQuarter(`Q${quarterNum}`);
        } catch (e) {
            console.error(e);
        } finally {
            console.log(currentQuarter);
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        getQuarter();
    }, []);

    return (
        <Card>
            {loading ? (<Loading />)
            : (
                <>
                    <CardHeader className='bg-white' style={{ display: 'flex', paddingInline: 20}}>
                        <span className='headerText' style={{ flex: 1 }}>Quarter</span>
                        <div style={{ flex: 1 }}></div>
                        <span className='headerText' style={{ flex: 1 }}>Sales Profit</span>
                        <span className='headerText' style={{ flex: 1 }}>Sales Quota</span>
                    </CardHeader>
                    <CardBody style={{ marginTop: 10 }}>
                        {data.map((item) => (
                            <Row key={item.quarter} style={{ display: 'flex', paddingInline: 20 }}>
                                <div style={{ flex: 1, marginBottom: 10 }}>
                                    <span className='headerText' key={item.quarter}>{item.quarter}</span>
                                </div>
                                <div style={{ flex: 1, marginBottom: 10 }}>
                                    {
                                        quarters.indexOf(item.quarter) > quarters.indexOf(currentQuarter)
                                        ? <DashIcon className='p-2' size={32}/>
                                        : Number(item.quarterQuotaPercent) >= 100
                                        ? <ArrowDropUp style={{ flex: 1, color: 'limegreen', fontSize: 32}} />
                                        : <ArrowDropDown style={{ flex: 1, color: 'red', fontSize: 32 }} /> 
                                    }
                                </div>
                                <div className='salesTabletOrange' style={{ flex: 1, marginBottom: 10, }}>
                                    <span className='tabletText'>{item.quarterQuotaPercent}%</span>
                                </div>
                                <div className='salesTabletGrey' style={{ flex: 1, marginBottom: 10 }}>
                                    <span className='tabletText'>{usdFormat.format(item.quarterQuotaCY)}</span>
                                </div>
                            </Row>
                        ))}
                    </CardBody>
                </>
            )}
        </Card>
    )
};

export default QuarterlySalesReportCard;